<template>
  <div class="message-carousel">
    <el-carousel height="60px" direction="vertical" :interval="6000" indicator-position="none">
      <el-carousel-item v-for="(item,index) in messageData" :key="index">
        <div class="message-content">
          <i class="iconfont icon-xiaoxi1"></i>
          <span class="message-text" v-html="getFormattedMessage(item.content)"></span>
          <el-button type="text" @click="handleClick(item)">查看</el-button>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  name: "Message",
  props: {
    messageData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getFormattedMessage(content) {
      // 使用正则表达式提取内容并去掉“查看”链接
      const regex = /<a[^>]*onclick="([^"]*)"[^>]*>查看<\/a>/g;
      return content.replace(regex, ''); // 去掉“查看”链接
    },
    handleClick(item) {
      const regex = /<a[^>]*onclick="([^"]*)"[^>]*>查看<\/a>/;
      const match = item.content.match(regex);
      if (match && match[1]) {
        const onclickFunction = match[1]; // 获取原来的 onclick 事件
        // 解析参数
        const urlMatch = onclickFunction.match(/readMessageAndJump\('([^']+)','([^']+)'\)/);
        if (urlMatch) {
          const url = urlMatch[1];
          const messageId = urlMatch[2];
          this.readMessageAndJump(url, messageId); // 调用 Vue 方法
        }
      }
    },
    readMessageAndJump(url, messageId) {
      // 处理消息阅读和跳转逻辑
      if (!url) return;
      if (url === './payCost.html') {
        window.open(`selfHelpPayCost.html#platformBillings`);
      } else {
        window.open(url);
      }
    },
  },
};
</script>
<style scoped lang="scss">
  .message-carousel {
    background-color: #E7F0FF; 
    height: 60px; 
    .el-carousel__item {
      .message-content{
        display: flex;
        align-items: center; 
        line-height: 60px;
        color: #5278E2; 
        font-size: 16px; 
        padding-left: 10px;
        white-space: nowrap;
        .icon-xiaoxi1{
          color: #5278E2; 
          font-size: 40px; 
        }
        .el-button{
          font-size: 16px;
          padding-left: 10px;
        }
      }
    }
  }
</style>